import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { TextField, Checkbox } from '../../common';

const UserInfo = ({
  styles,
  firstName,
  onSubmit,
  profile,
  UserInfoItemComponent: UserInfoItem,
}) => (
  <div className={styles['profile-user-info__wrapper']}>
    <div className={styles['profile-user-info__content']}>
      <div
        className={classNames(
          styles['profile-user-info__user-info'],
          styles['profile-user-info__table']
        )}
      >
        <UserInfoItem
          onSubmit={onSubmit}
          type="NEW_LAST_NAME"
          initialValues={{ lastname: profile.lastname }}
        >
          <div className={styles['profile-user-info__table-title']}>
            Neuer Nachname
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Vorname
            </div>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-3']
              )}
            >
              {firstName}
            </div>
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Nachname
            </div>
            <TextField
              placeholder="Meier-Müller-Schulze"
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-3'],
                styles['profile-user-info__control']
              )}
              classNameInput={classNames(
                styles['profile-user-info__text-field-input']
              )}
              name="lastname"
            />
          </div>
        </UserInfoItem>
        <UserInfoItem
          onSubmit={onSubmit}
          type="NEW_ADDRESS"
          initialValues={{
            postcode: profile.postcode,
            ort: profile.ort,
            street: profile.street,
          }}
        >
          <div className={styles['profile-user-info__table-title']}>
            Neue Post-Anschrift
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Postleitzahl
            </div>
            <div className={styles['fl-3']}>
              <div className={styles['profile-user-info__table-row']}>
                <TextField
                  placeholder="00000"
                  type="number"
                  className={classNames(
                    styles['profile-user-info__table-cell'],
                    styles['profile-user-info__control'],
                    styles['fl-1']
                  )}
                  classNameInput={classNames(
                    styles['profile-user-info__text-field-input']
                  )}
                  name="postcode"
                />
                <div
                  className={classNames(
                    styles['profile-user-info__table-cell-center']
                  )}
                >
                  Ort
                </div>
                <TextField
                  placeholder="00000"
                  className={classNames(
                    styles['profile-user-info__table-cell'],
                    styles['profile-user-info__control'],
                    styles['fl-2']
                  )}
                  classNameInput={classNames(
                    styles['profile-user-info__text-field-input']
                  )}
                  name="ort"
                />
              </div>
            </div>
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Straße Nr.
            </div>
            <TextField
              placeholder="ABC-Straße 99"
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['profile-user-info__control'],
                styles['fl-3']
              )}
              classNameInput={classNames(
                styles['profile-user-info__text-field-input']
              )}
              name="street"
            />
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Bitte kontaktiert mich vorrangig per Post.
            </div>
            <Checkbox
              id="page.profile.component.user-info.contact-by-post-checkbox"
              className={classNames(styles['profile-user-info__checkbox'])}
            />
          </div>
        </UserInfoItem>
        <UserInfoItem
          onSubmit={onSubmit}
          type="NEW_PHONE_NUMBER"
          initialValues={{ landlineNumber: profile.landlineNumber }}
        >
          <div className={styles['profile-user-info__table-title']}>
            Neue Festnetz-Nummer
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Nummer
            </div>
            <TextField
              placeholder="01234-1234567"
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['profile-user-info__control'],
                styles['fl-3']
              )}
              classNameInput={classNames(
                styles['profile-user-info__text-field-input']
              )}
              name="landlineNumber"
            />
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Bitte ruft mich auf dieser Nummer an.
            </div>
            <Checkbox
              id="page.profile.component.user-info.call-me-phone-checkbox"
              className={classNames(styles['profile-user-info__checkbox'])}
            />
          </div>
        </UserInfoItem>
        <UserInfoItem
          onSubmit={onSubmit}
          type="NEW_MOBILE_PHONE_NUMBER"
          initialValues={{ mobile: profile.mobileNumber }}
        >
          <div className={styles['profile-user-info__table-title']}>
            Neue Handy-Nummer
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Nummer
            </div>
            <TextField
              placeholder="01234-1234567"
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['profile-user-info__control'],
                styles['fl-3']
              )}
              classNameInput={classNames(
                styles['profile-user-info__text-field-input']
              )}
              name="mobile"
            />
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Bitte ruft mich auf dieser Nummer an.
            </div>
            <Checkbox
              id="page.profile.component.user-info.call-me-mobile-checkbox"
              className={classNames(styles['profile-user-info__checkbox'])}
            />
          </div>
        </UserInfoItem>
        <UserInfoItem
          onSubmit={onSubmit}
          type="NEW_EMAIL"
          initialValues={{ email: profile.email }}
        >
          <div className={styles['profile-user-info__table-title']}>
            Neue E-Mail-Adresse
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              E-Mail-Addresse
            </div>
            <TextField
              placeholder="abc@abc.de"
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['profile-user-info__control'],
                styles['fl-3']
              )}
              classNameInput={classNames(
                styles['profile-user-info__text-field-input']
              )}
              name="email"
            />
          </div>
          <div className={styles['profile-user-info__table-row']}>
            <div
              className={classNames(
                styles['profile-user-info__table-cell'],
                styles['fl-1']
              )}
            >
              Bitte nutzt diese E-Mail-Adresse.
            </div>
            <Checkbox
              id="page.profile.component.user-info.contact-by-email-checkbox"
              className={classNames(styles['profile-user-info__checkbox'])}
            />
          </div>
        </UserInfoItem>
      </div>
    </div>
  </div>
);

UserInfo.propTypes = {
  styles: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default UserInfo;
